import "./industries.css";
import SEO from "../../SEO";

/* ── SVG icons ─────────────────────────────────────────────────────────── */
const HospitalIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

const TeleIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="2" y="3" width="20" height="14" rx="2" />
    <line x1="8" y1="21" x2="16" y2="21" />
    <line x1="12" y1="17" x2="12" y2="21" />
    <path d="M9 7h6M12 7v4" />
  </svg>
);

const EHRIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="12" y1="18" x2="12" y2="12" />
    <line x1="9" y1="15" x2="15" y2="15" />
  </svg>
);

const BrainIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
);

const CalIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const HeartIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);

const ShieldIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <polyline points="9 12 11 14 15 10" />
  </svg>
);

const ZapIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);

const CheckIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const ArrowIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

/* ── Data ───────────────────────────────────────────────────────────────── */
const solutions = [
  {
    icon: <HospitalIcon />,
    title: "Hospital Management Systems",
    tag: "Core Ops",
    desc: "End-to-end HMS covering patient records, ward management, billing, inventory, and staff scheduling — all on a single platform.",
  },
  {
    icon: <TeleIcon />,
    title: "Telemedicine Applications",
    tag: "Remote Care",
    desc: "HIPAA-ready video consultation platforms with digital prescriptions, e-pharmacy integration, and real-time patient monitoring.",
  },
  {
    icon: <EHRIcon />,
    title: "Electronic Health Records (EHR)",
    tag: "Patient Data",
    desc: "Secure, interoperable EHR systems with structured clinical data, lab integration, and instant access across departments.",
  },
  {
    icon: <BrainIcon />,
    title: "AI Diagnosis Support Systems",
    tag: "AI Medicine",
    desc: "ML-powered clinical decision support tools that analyse symptoms, imaging, and lab reports to surface evidence-based diagnoses.",
  },
  {
    icon: <CalIcon />,
    title: "Appointment & Scheduling Systems",
    tag: "Patient Flow",
    desc: "Smart scheduling with doctor availability calendars, automated reminders, queue management, and no-show reduction logic.",
  },
];

const projects = [
  {
    icon: <BrainIcon />,
    tag: "AI · Diagnosis",
    title: "AI Diagnosis Assistant",
    desc: "Helps clinicians analyse patient symptoms, lab results, and imaging reports through ML models — surfacing evidence-based diagnoses with confidence scores.",
    features: [
      "Symptom-to-diagnosis ML engine",
      "Lab & imaging report analysis",
      "Evidence-based recommendation engine",
    ],
  },
  {
    icon: <CalIcon />,
    tag: "Scheduling · Booking",
    title: "Appointment Booking App",
    desc: "A patient-facing scheduling platform with real-time doctor availability, smart slot allocation, automated reminders, and integrated video consultation.",
    features: [
      "Real-time doctor availability",
      "Automated SMS & email reminders",
      "Video consultation integration",
    ],
  },
  {
    icon: <HospitalIcon />,
    tag: "Operations · Platform",
    title: "Hospital Management System",
    desc: "A full-stack HMS covering patient admission, ward management, billing, pharmacy, lab results, and staff rosters — all under one unified dashboard.",
    features: [
      "Unified patient & billing records",
      "Pharmacy & lab module integration",
      "Staff scheduling & payroll management",
    ],
  },
];

const benefits = [
  {
    icon: <HeartIcon />,
    title: "Improved Patient Care",
    desc: "A single longitudinal record across departments — so medication history, allergies, and prior episodes are present at the point of care, not chased down.",
  },
  {
    icon: <ZapIcon />,
    title: "Faster Diagnosis",
    desc: "Decision-support models surface relevant history, lab values, and prior imaging alongside the current case, so clinicians spend less time assembling context.",
  },
  {
    icon: <HospitalIcon />,
    title: "Efficient Hospital Operations",
    desc: "Automated scheduling, claims, and stock reconciliation cut the administrative load that pulls clinical staff away from patients.",
  },
  {
    icon: <ShieldIcon />,
    title: "Secure Data Management",
    desc: "Encryption at rest and in transit, role-based access by clinical role, and immutable audit trails — architected to the safeguards HIPAA requires.",
  },
];

/* ── Component ──────────────────────────────────────────────────────────── */
export default function Healthcare() {
  return (
    <>
      <SEO
        title="Healthcare AI: Clinical & HealthTech Software | Best Code Technology"
        description="AI-based healthcare solutions for diagnostics, patient management and analytics."
        keywords="healthcare AI, medical software, health tech"
        url="https://bestcodetechnology.in/industries/healthcare"
      />
      <div className="ind-page ind-page--healthcare">
        {/* ════════════════════════════════════════════════════════════════════
          HERO — split layout: left content, right patient dashboard mockup
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="fin-hero">
          <div className="container-xl">
            <div className="row align-items-center g-5">
              {/* Left: Content */}
              <div className="col-12 col-lg-6">
                <div className="fin-hero__eyebrow">
                  <div className="fin-hero__icon-wrap" aria-hidden="true">
                    <HospitalIcon />
                  </div>
                  <span className="pill-label">Healthcare Industry</span>
                </div>

                <h1 className="fin-hero__headline">
                  Smart Healthcare <br />
                  <span>Solutions for Better</span>
                  <br />
                  Patient Outcomes
                </h1>

                <p className="fin-hero__desc">
                  We create healthcare applications that improve patient care,
                  streamline clinical operations, and enable data-driven
                  decisions — built for hospitals, clinics, and digital health
                  platforms.
                </p>

                <div className="fin-hero__actions">
                  <a href="#solutions" className="fin-btn-primary">
                    Explore Solutions
                    <ArrowIcon />
                  </a>
                  <a href="#projects" className="fin-btn-ghost">
                    See What We Build
                  </a>
                </div>

                <div className="fin-hero__stats">
                  <div className="fin-stat">
                    <span className="fin-stat__value">HIPAA</span>
                    <span className="fin-stat__label">Aligned Controls</span>
                  </div>
                  <div className="fin-stat__sep" aria-hidden="true" />
                  <div className="fin-stat">
                    <span className="fin-stat__value">AI-First</span>
                    <span className="fin-stat__label">Diagnosis Support</span>
                  </div>
                  <div className="fin-stat__sep" aria-hidden="true" />
                  <div className="fin-stat">
                    <span className="fin-stat__value">Real-Time</span>
                    <span className="fin-stat__label">Patient Monitoring</span>
                  </div>
                  <div className="fin-stat__sep" aria-hidden="true" />
                  <div className="fin-stat">
                    <span className="fin-stat__value">HL7 FHIR</span>
                    <span className="fin-stat__label">Interoperable</span>
                  </div>
                </div>
              </div>

              {/* Right: Patient Monitoring Dashboard Mockup */}
              <div className="col-12 col-lg-6">
                <div className="fin-dashboard hc-dashboard">
                  {/* Top bar */}
                  <div className="fin-dashboard__bar">
                    <div className="fin-dashboard__title">
                      <div className="fin-dashboard__dot" aria-hidden="true" />
                      Patient Monitoring
                    </div>
                    <span className="fin-dashboard__live">● Live</span>
                  </div>

                  <div className="fin-dashboard__body">
                    {/* Vitals row */}
                    <div className="hc-vitals-row">
                      <div className="hc-vital hc-vital--normal">
                        <span className="hc-vital__icon" aria-hidden="true">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                          </svg>
                        </span>
                        <span className="hc-vital__value">72 bpm</span>
                        <span className="hc-vital__label">Heart Rate</span>
                      </div>
                      <div className="hc-vital hc-vital--normal">
                        <span className="hc-vital__icon" aria-hidden="true">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
                          </svg>
                        </span>
                        <span className="hc-vital__value">98.6°</span>
                        <span className="hc-vital__label">Temperature</span>
                      </div>
                      <div className="hc-vital hc-vital--normal">
                        <span className="hc-vital__icon" aria-hidden="true">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="12" />
                            <line x1="12" y1="16" x2="12.01" y2="16" />
                          </svg>
                        </span>
                        <span className="hc-vital__value">98%</span>
                        <span className="hc-vital__label">SpO₂</span>
                      </div>
                      <div className="hc-vital hc-vital--alert">
                        <span className="hc-vital__icon" aria-hidden="true">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                          </svg>
                        </span>
                        <span className="hc-vital__value">142/90</span>
                        <span className="hc-vital__label">Blood Pressure</span>
                      </div>
                    </div>

                    {/* Chart — patient load per hour */}
                    <div className="fin-chart">
                      <div className="fin-chart__header">
                        <span className="fin-chart__label">
                          Patient Visits — Today
                        </span>
                        <span className="fin-chart__tag">48 Today</span>
                      </div>
                      <div className="fin-bars" aria-hidden="true">
                        <div className="fin-bar hc-bar" />
                        <div className="fin-bar hc-bar" />
                        <div className="fin-bar hc-bar" />
                        <div className="fin-bar hc-bar" />
                        <div className="fin-bar hc-bar" />
                        <div className="fin-bar hc-bar" />
                        <div className="fin-bar hc-bar" />
                        <div className="fin-bar hc-bar" />
                      </div>
                    </div>

                    {/* Appointment feed */}
                    <div className="fin-feed">
                      <div className="fin-feed__row">
                        <div
                          className="fin-feed__icon fin-feed__icon--success"
                          aria-hidden="true"
                        >
                          <svg
                            width="13"
                            height="13"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                        </div>
                        <div>
                          <span className="fin-feed__text">
                            Ravi Kumar — Consultation
                          </span>
                          <span className="fin-feed__sub">
                            Dr. Priya Sharma · 10:00 AM
                          </span>
                        </div>
                        <span className="hc-status hc-status--done">Done</span>
                      </div>
                      <div className="fin-feed__row">
                        <div
                          className="fin-feed__icon fin-feed__icon--alert"
                          aria-hidden="true"
                        >
                          <svg
                            width="13"
                            height="13"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <circle cx="12" cy="12" r="10" />
                            <polyline points="12 6 12 12 16 14" />
                          </svg>
                        </div>
                        <div>
                          <span className="fin-feed__text">
                            Sunita Reddy — Lab Reports
                          </span>
                          <span className="fin-feed__sub">
                            Pathology · Awaiting AI Analysis
                          </span>
                        </div>
                        <span className="hc-status hc-status--pending">
                          Pending
                        </span>
                      </div>
                      <div className="fin-feed__row">
                        <div
                          className="fin-feed__icon fin-feed__icon--success"
                          aria-hidden="true"
                        >
                          <svg
                            width="13"
                            height="13"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                        </div>
                        <div>
                          <span className="fin-feed__text">
                            Amit Singh — Telemedicine
                          </span>
                          <span className="fin-feed__sub">
                            Dr. Arjun Nair · 11:30 AM
                          </span>
                        </div>
                        <span className="hc-status hc-status--done">
                          Confirmed
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ════════════════════════════════════════════════════════════════════
          SOLUTIONS — horizontal feature rows
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="fin-solutions" id="solutions">
          <div className="container-xl">
            <div className="row justify-content-center mb-4 mb-lg-5">
              <div className="col-12 col-md-10 col-lg-7 text-center">
                <span className="pill-label">Key Solutions</span>
                <h2 className="ind-section-title mt-3">
                  Healthcare Systems Built for Care &amp; Compliance
                </h2>
                <p className="ind-section-sub">
                  Five specialised product lines covering every layer of modern
                  healthcare infrastructure — from patient-facing apps to
                  backend clinical intelligence engines.
                </p>
              </div>
            </div>

            <div className="row g-4">
              <div className="col-12 col-lg-8">
                <div className="fin-sol-list">
                  {solutions.map((item, i) => (
                    <div key={i} className="fin-sol-row">
                      <div className="fin-sol-row__icon">{item.icon}</div>
                      <div className="fin-sol-row__content">
                        <h4 className="fin-sol-row__title">{item.title}</h4>
                        <p className="fin-sol-row__desc">{item.desc}</p>
                      </div>
                      <span className="fin-sol-row__tag">{item.tag}</span>
                      <span className="fin-sol-row__arrow">
                        <ArrowIcon />
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Callout */}
              <div className="col-12 col-lg-4">
                <div className="fin-callout">
                  <div className="fin-callout__icon" aria-hidden="true">
                    <ShieldIcon />
                  </div>
                  <h3 className="fin-callout__title">
                    Built for Regulated Healthcare Environments
                  </h3>
                  <p className="fin-callout__desc">
                    Every system is architected with HIPAA, DISHA, and HL7 FHIR
                    compliance baked in. Patient data privacy and clinical
                    interoperability are not add-ons — they are core
                    requirements.
                  </p>
                  <ul className="fin-callout__list">
                    <li>
                      <CheckIcon />
                      <span>HIPAA-aligned data architecture</span>
                    </li>
                    <li>
                      <CheckIcon />
                      <span>End-to-end patient data encryption</span>
                    </li>
                    <li>
                      <CheckIcon />
                      <span>HL7 FHIR interoperability</span>
                    </li>
                    <li>
                      <CheckIcon />
                      <span>Role-based clinical access control</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ════════════════════════════════════════════════════════════════════
          TECHNOLOGIES — 2×2 category cards
      ═══════════════════════════════════════════════════════════════════════ */}

        {/* ════════════════════════════════════════════════════════════════════
          PROJECTS — showcase cards with dark preview header
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="fin-projects" id="projects">
          <div className="container-xl">
            <div className="row justify-content-center mb-4 mb-lg-5">
              <div className="col-12 col-md-10 col-lg-7 text-center">
                <span className="pill-label">Platform Capabilities</span>
                <h2 className="ind-section-title mt-3">
                  What We Build for Healthcare
                </h2>
                <p className="ind-section-sub">
                  Three platform builds we take on for clinical teams — spanning
                  AI diagnostics, scheduling, and hospital operations.
                </p>
              </div>
            </div>

            <div className="row g-4">
              {projects.map((project, i) => (
                <div key={i} className="col-12 col-lg-4">
                  <div className="fin-project-card">
                    <div className="fin-project-card__preview">
                      <div className="fin-project-card__preview-icon">
                        {project.icon}
                      </div>
                    </div>
                    <div className="fin-project-card__body">
                      <span className="fin-project-card__tag">
                        {project.tag}
                      </span>
                      <h3 className="fin-project-card__title">
                        {project.title}
                      </h3>
                      <p className="fin-project-card__desc">{project.desc}</p>
                      <ul className="fin-project-card__features">
                        {project.features.map((feat, fi) => (
                          <li key={fi}>
                            <CheckIcon />
                            <span>{feat}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ════════════════════════════════════════════════════════════════════
          BENEFITS — dark split: left headline+CTA, right benefit list
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="fin-benefits">
          <div className="container-xl">
            <div className="row align-items-center g-5 g-lg-8">
              {/* Left */}
              <div className="col-12 col-lg-5">
                <span className="ind-pill-dark">Why BCT</span>
                <h2 className="fin-benefits__headline mt-4">
                  The Advantage of
                  <br />
                  <span>Building with BCT</span>
                </h2>
                <p className="fin-benefits__sub">
                  From HIPAA-aligned architecture to AI-powered clinical
                  intelligence, every healthcare system we build is engineered
                  to deliver better outcomes — for patients and providers alike.
                </p>
                <a href="/services/ai-applications" className="fin-btn-primary">
                  Start a Project
                  <ArrowIcon />
                </a>
              </div>

              {/* Right */}
              <div className="col-12 col-lg-7">
                <div className="fin-benefit-list">
                  {benefits.map((b, i) => (
                    <div key={i} className="fin-benefit-item">
                      <div className="fin-benefit-item__icon">{b.icon}</div>
                      <div>
                        <h4 className="fin-benefit-item__title">{b.title}</h4>
                        <p className="fin-benefit-item__desc">{b.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
